export default __webpack_public_path__ + "static/media/dutchgot-screenshot-02.72935a69.png";